import { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import TasksContext from "../context/tasks-content";
import AddNewTasks from "../Pages/AddNewTasks";
import Dashboard from "../Pages/Dashbord";
import LoginPage from "../Pages/LoginPage";
import TaskDetales from "../Pages/TaskDetailesPage";
import TaskPage from "../Pages/TaskPage";

const AppRoute = ()=>{
  let tasksContext = useContext(TasksContext);
  return (
    
     <Routes>
        {/* <Route path="/dashbord"  element={ <Navigate to="/dashbord/tasks"/>}/> */}
        <Route 
        path="/dashbord"  
        element={
         JSON.parse(tasksContext.isLoggedIn) ? (
          <Dashboard/>
          ):(
          <Navigate to="/login"/>
          )
        }
      >
        <Route path="/dashbord/tasks"  element={<TaskPage/>}/>
        <Route path="/dashbord/tasks/new-task"  element={<AddNewTasks/>}/>
        <Route path="/dashbord/tasks/:id/details" element={<TaskDetales/>}/>
      </Route>
      <Route path="/login" 
         element={ 
          JSON.parse(tasksContext.isLoggedIn)  !== true ? (
          <LoginPage/>
        ) : (
        <Navigate to="/dashbord"/>
        )

        }/>

      <Route path="/*"  
      element={  
        JSON.parse(tasksContext.isLoggedIn) !== true ? (
          <Navigate to="/login" />
        ) : (
          <Navigate to="/dashbord" />)
    }/>

    </Routes>
  )
}
export default AppRoute;